import isCore from 'common/util/isCore';
import { isFreeV4 } from 'common/util/isFree';
import isPro from 'common/util/isPro';

export default function isOnNewPricingPlan(planID?: string | null) {
  // expired plans are considered to be on new pricing plans
  if (!planID) {
    return true;
  }

  return isFreeV4(planID) || isCore(planID) || isPro(planID);
}
